import { address as btcAddressLib } from "bitcoinjs-lib";

// Validation taken from Squid API repo
export const isBitcoinAddressValid = (address: string): boolean => {
  try {
    if (address.startsWith("bc1p")) {
      // this is a bitcoin taproot address type, it has different encoding than other 3 address types
      // and requires different validation logic
      const decoded = btcAddressLib.fromBech32(address);
      return decoded.prefix === "bc" && decoded.version === 1;
    } else {
      btcAddressLib.toOutputScript(address);
      return true;
    }
  } catch (e) {
    return false;
  }
};
